import { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useRoleCookie from "shared/model/useRoleCookie"
import { ROLE_EXTERNAL_ADMIN } from "shared/constant/lookup/role"

const useGetEventDetail = () => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const [roleCookie] = useRoleCookie()

    useEffect(() => {
        if ([ROLE_EXTERNAL_ADMIN].includes(roleCookie)) {
            fetchRequest("GET", `/external-admin/event/${idx}/detail`)
        }else{
            fetchRequest("GET", `/admin/event/${idx}/detail`)
        }
    }, [])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 404:
                setAlert("대회 데이터가 존재하지 않습니다.")
                navigate("/select")
                break
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetEventDetail